import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getClientConfig } from 'domains/appContext/AppContext.store';
import { EcosystemLinkAntCard } from 'pages/MotrioEcosystemPage/EcosystemLinkCard/EcosystemLinkCard';
import { Box, Flex, MarginBox, Text } from 'UI';
import { useResetScroll } from 'utils/hooks/useResetScroll';
import { getEcosystemLinks } from './ecosystemLinksData';

const SText = styled(Text)`
  text-align: center;
`;

const MotrioEcosystemPage = () => {
  const { t } = useTranslation();
  const clientConfig = useSelector(getClientConfig);

  useResetScroll();

  const ecosystemLinks = getEcosystemLinks(t, clientConfig);

  return (
    <Flex justify={'center'} align={'center'}>
      <Box>
        <MarginBox mt={25}>
          <Flex direction={'column'} align={'center'} gap={30} maxWidth={2000}>
            <SText type={'h0'} disableGutter>
              {t('motrio_ecosystem.title', 'Discover Motrio Ecosystem')}
            </SText>
            <SText type={'h6_black_45'}>
              {t(
                'motrio_ecosystem.description',
                'Access your partner portals in one click: sales promotions, offers, ' +
                  'oils, online reputation management, leasing and rewards.',
              )}
            </SText>
            <Flex direction={'row'} align={'stretch'} gap={20} wrap={'wrap'} justify={'center'}>
              {ecosystemLinks.map((link) => (
                <EcosystemLinkAntCard key={link.key} link={link} />
              ))}
            </Flex>
          </Flex>
          <MarginBox mt={48} />
        </MarginBox>
      </Box>
    </Flex>
  );
};

export default MotrioEcosystemPage;
